<template>

    <div class="bg-white overflow-hidden shadow rounded-lg relative pb-20 lg:col-span-2">

        <div class="px-4 py-5 sm:rounded-lg sm:p-6 mb-2">
            <div class="panel-form">
                <div class="panel-title">
                    <h3>Cost Index</h3>
                    <p>
                        Update an accounts cost index.
                    </p>
                </div>
                <div class="panel-section">
                    <div class="grid grid-cols-6 gap-6">
                        <div class="form-control col-span-6 xl:col-span-4">
                            <label for="account_id" class="block text-sm font-medium text-gray-700">Cost Index</label>
                            <select name="account_id" id="account_id" v-model="model.data.cost_index" @change="model.updateAccountCostIndex()">
                                <option :value="cost_index.id" v-for="cost_index in value.cost_indexes.data">{{ cost_index.id }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="px-4 py-5 sm:rounded-lg sm:p-6 mb-2">
            <div class="panel-form">
                <div class="panel-title">
                    <h3>Tenant</h3>
                    <p>
                        Set a tenant on an account.
                    </p>
                </div>
                <div class="panel-section">
                    <div class="grid grid-cols-6 gap-6">
                        <div class="form-control col-span-6 xl:col-span-4">
                            <label for="account_id" class="block text-sm font-medium text-gray-700">Tenant</label>
                            <select name="account_tenant" id="account_tenant" v-model="model.data.tenant_name" @change="model.toggleConfirmationModal()">
                                <option :value="null">No Tenant</option>
                                <option :value="tenant.name" v-for="tenant in value.tenants.data">{{ tenant.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="px-4 py-5 sm:rounded-lg sm:p-6">
            <div class="panel-form">
                <div class="panel-title">
                    <h3>Finance / Invoicing</h3>
                    <p>
                        Update account finance and invoicing settings.
                    </p>
                </div>
                <div class="panel-section">
                    <div class="flex">
                        <div class="flex items-center pr-6">
                            <input name="has_unlimited_funds" v-model="model.data.has_unlimited_funds" id="has_unlimited_funds" class="h-4 w-4 text-brand-500 focus:ring-brand-500 border-gray-300 rounded" type="checkbox" @change="model.toggleConfirmationModal()">
                            <label for="has_unlimited_funds" class="ml-2 block text-sm text-gray-900" >
                                Unlimited funds
                            </label>
                        </div>

                        <div class="flex items-center pr-6">
                            <input name="should_invoice" v-model="model.data.should_invoice" id="should_invoice" class="h-4 w-4 text-brand-500 focus:ring-brand-500 border-gray-300 rounded" type="checkbox" @change="model.toggleConfirmationModal()">
                            <label for="should_invoice" class="ml-2 block text-sm text-gray-900" >
                                Should Invoice
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="px-4 py-5 sm:rounded-lg sm:p-6">
            <div class="panel-form">
                <div class="panel-title">
                    <h3>Permissions</h3>
                    <p>
                        Update account permission settings.
                    </p>
                </div>
                <div class="panel-section">
                    <div class="flex">
                        <div class="flex items-center pr-6">
                            <input name="order_customer_permissions" v-model="model.data.order_customer_permissions" id="order_customer_permissions" class="h-4 w-4 text-brand-500 focus:ring-brand-500 border-gray-300 rounded" type="checkbox" @change="model.toggleConfirmationModal()">
                            <label for="order_customer_permissions" class="ml-2 block text-sm text-gray-900" >
                                Order Customer
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex bg-gray-50 px-5 py-3 text-sm text-gray-400 absolute bottom-0 left-0 right-0">
            <p class="w-1/4 text-left">
                Name <span class="font-medium text-gray-500 ml-1">{{ model.data.name }}</span>
            </p>
            <p class="w-1/4 text-center">
                Tenant <span class="font-medium text-gray-500 ml-1">{{  model.data.tenant_name ? model.data.tenant_name : '-' }}</span>
            </p>
            <p class="w-1/4 text-center">
                Discount Reduction <span class="font-medium text-gray-500 ml-1">{{ model.data.cost_index_reduction / 100 }}%</span>
            </p>
            <p class="w-1/4 text-right">
                Item Transaction Fee <span class="font-medium text-gray-500 ml-1">{{ model.data.cost_index_fee / 100 }}</span>
            </p>
        </div>

        <!-- confirmation modal-->
        <div>
            <transition
                enter-active-class="ease-out duration-300"
                enter-from-class="opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="ease-in duration-200"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <div class="fixed z-50 inset-0 overflow-y-auto" role="dialog" aria-modal="true" aria-hidden="false" v-show="model.showConfirmationModal">
                    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" @click="model.cancelModal()"></div>

                        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                        <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                            <div>
                                <div class="mt-3 text-center sm:mt-5">
                                    <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                                        Please confirm the account settings:-
                                    </h3>
                                    <div class="mt-2">
                                        <p class="text-sm text-gray-500">
                                            Are you sure you want to update account settings? Please Note: Updating a tenant will remove account products and discounts.
                                        </p>

                                        <table class="index-table px-10 mx-auto mt-6">
                                            <thead>
                                                <tr class="font-medium">
                                                    <td class="p-2">&nbsp;</td>
                                                    <td class="p-2">Original Value</td>
                                                    <td class="p-2">Previous Value</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td class="font-medium text-left">Cost Index</td>
                                                    <td class="text-center">{{ model.dataCache.cost_index }}</td>
                                                    <td class="text-center">{{ model.data.cost_index }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="p-2 font-medium text-left">Tenant</td>
                                                    <td class="p-2 text-center">{{ model.dataCache.tenant_name }}</td>
                                                    <td class="p-2 text-center">{{ model.data.tenant_name }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="p-2 font-medium text-left">Unlimited Funds</td>
                                                    <td class="p-2 text-center">
                                                        <span class="status-box" :class="{ 'status-complete': model.dataCache.has_unlimited_funds, 'status-cancelled': !model.dataCache.has_unlimited_funds }">
                                                            {{ model.dataCache.has_unlimited_funds ? 'enabled' : 'disabled' }}
                                                        </span>
                                                    </td>
                                                    <td class="p-2 text-center">
                                                        <span class="status-box" :class="{ 'status-complete': model.data.has_unlimited_funds, 'status-cancelled': !model.data.has_unlimited_funds }">
                                                            {{ model.data.has_unlimited_funds ? 'enabled' : 'disabled' }}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="p-2 font-medium text-left">Should Invoice</td>
                                                    <td class="p-2 text-center">
                                                        <span class="status-box" :class="{ 'status-complete': model.dataCache.should_invoice, 'status-cancelled': !model.dataCache.should_invoice }">
                                                            {{ model.dataCache.should_invoice ? 'enabled' : 'disabled' }}
                                                        </span>
                                                    </td>
                                                    <td class="p-2 text-center">
                                                        <span class="status-box" :class="{ 'status-complete': model.data.should_invoice, 'status-cancelled': !model.data.should_invoice }">
                                                            {{ model.data.should_invoice ? 'enabled' : 'disabled' }}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="p-2 font-medium text-left">Order Customer Permissions</td>
                                                    <td class="p-2 text-center">
                                                        <span class="status-box" :class="{ 'status-complete': model.dataCache.order_customer_permissions, 'status-cancelled': !model.dataCache.order_customer_permissions }">
                                                            {{ model.dataCache.order_customer_permissions ? 'enabled' : 'disabled' }}
                                                        </span>
                                                    </td>
                                                    <td class="p-2 text-center">
                                                        <span class="status-box" :class="{ 'status-complete': model.data.order_customer_permissions, 'status-cancelled': !model.data.order_customer_permissions }">
                                                            {{ model.data.order_customer_permissions ? 'enabled' : 'disabled' }}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="flex mt-5 sm:mt-6 w-full">
                                <button type="button" class="flex-1 btn-outline justify-center mx-1" @click="model.cancelModal()">
                                    Cancel
                                </button>
                                <button type="button" class="flex-1 btn justify-center mx-1" @click="model.updateAccountSettings()">
                                    Confirm
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>

</template>
<script>
import {AccountSettings} from "../../app/Auth/AccountSettings";

export default {
    name: "AccountSettings",
    props: {
        accountId: {
            require: true,
        },
        value: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            model: new AccountSettings(this.accountId, this.value.data),
        }
    },
}
</script>
